export default __webpack_public_path__ + "static/media/zyfzr.59566c5c.jpg";